// ⌘K: Bob global — Frage oder Auftrag ohne geöffnete Mail. Entwürfe öffnen den Thread mit dem Entwurf.
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../lib/api.ts';
import { BobAntwort } from './BobAntwort.tsx';

const BEISPIELE = [
  'Schreib Susanne eine Antwort und sag ihr auch, dass sie ruhig mal die Option ALL-IN in Betracht ziehen soll.',
  'Was steht heute an?',
  'Welche Schulsong-Anfragen sind seit Montag offen?',
  'Welche Mails warten seit mehr als 5 Tagen auf eine Antwort von der Schule?',
];

export function Palette({ onClose }: { onClose: () => void }) {
  const nav = useNavigate();
  const [q, setQ] = useState('');
  const [state, setState] = useState<{
    laden: boolean;
    antwort?: string;
    error?: string;
    kosten?: number;
    schritte?: Array<{ tool: string }>;
  } | null>(null);
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    ref.current?.focus();
    const h = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);
  const go = (frage: string) => {
    const f = frage.trim();
    if (!f || state?.laden) return;
    setQ(f);
    setState({ laden: true });
    void api
      .bobFrage(f)
      .then((r) => {
        if (r.draftId && r.threadId) {
          onClose();
          void nav(`/t/${r.threadId}?draft=${r.draftId}`);
          return;
        }
        setState({
          laden: false,
          antwort: r.antwort,
          kosten: r.kostenEur,
          schritte: r.schritte,
          ...(r.error ? { error: r.error } : {}),
        });
      })
      .catch((e: Error) => setState({ laden: false, error: e.message }));
  };
  return (
    <div className="pal-wrap" onClick={onClose}>
      <div
        className="pal"
        role="dialog"
        aria-label="Bob fragen"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pal-in">
          <span className="bob-av" aria-hidden="true">
            ✦
          </span>
          <input
            ref={ref}
            placeholder="Bob fragen oder einen Auftrag geben …"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && go(q)}
            disabled={!!state?.laden}
          />
          <button className="btn bob" onClick={() => go(q)} disabled={!!state?.laden}>
            {state?.laden ? 'Bob arbeitet …' : 'Los'}
          </button>
        </div>
        {!state && (
          <div className="pal-ex">
            {BEISPIELE.map((b) => (
              <button key={b} onClick={() => go(b)}>
                {b}
              </button>
            ))}
            <p className="muted" style={{ fontSize: 12, padding: '4px 10px', margin: 0 }}>
              Antworten mit Thread-Links · Entwürfe landen im Editor · nichts wird ohne dich
              verschickt. Für Suche mit Filtern: ⌘F.
            </p>
          </div>
        )}
        {state && (
          <div className="pal-out">
            {state.laden && (
              <span>
                <span className="spin" /> Bob liest den Posteingang und sucht …
              </span>
            )}
            {state.error && <p className="err">{state.error}</p>}
            {state.antwort && <BobAntwort text={state.antwort} />}
            {!state.laden && (
              <div className="muted" style={{ fontSize: 12, marginTop: 8 }}>
                {state.schritte?.map((s) => s.tool).join(' → ')}
                {state.kosten ? ` · ${state.kosten.toFixed(3)} €` : ''}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
